module.exports = __webpack_public_path__ + "img/home_slider_08.d51ee4c8.jpg";